import { useContext } from 'react';
import { SpaceContext } from '../contexts/SpaceContext';

export function useSpace() {
  const context = useContext(SpaceContext);
  if (context === undefined) {
    throw new Error('useSpace must be used within a SpaceProvider');
  }
  return context;
}
